export const errorCodes = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
};
